import { isEmpty } from 'lodash';
import * as Immutable from 'immutable';
import { createReducer } from '../utils';
import * as actionTypes from '../actionTypes/localCourtSearchActionTypes';

const initialState = Immutable.fromJS({
  data: [],
  receipts: [],
  error: null,
  isLoading: false,
  searchResultsType: null,
  searchType: null,
});

export default createReducer(initialState, {
  [actionTypes.LOCAL_COURT_SEARCH_BANKRUPTCY.REQUEST]: state =>
    state.merge(Immutable.fromJS({ isLoading: true })),

  [actionTypes.LOCAL_COURT_SEARCH_BANKRUPTCY.ERROR]: (state, { error }) =>
    state.merge(Immutable.fromJS({ error, isLoading: false })),

  [actionTypes.LOCAL_COURT_SEARCH_BANKRUPTCY.SUCCESS]: (state, action) => {
    let data = [];
    let searchResultsType = 'empty';

    if (!isEmpty(action.searchResults.cases)) {
      // result type cases
      data = action.searchResults.cases;
      searchResultsType = 'cases';
    } else if (!isEmpty(action.searchResults.parties)) {
      // result type parties
      data = action.searchResults.parties;
      searchResultsType = 'parties';
    }

    return state.merge({
      searchResultsType,
      searchType: 'Bankruptcy',
      data,
      receipts: action.searchResults.receipts || [],
      isLoading: false,
    });
  },

  [actionTypes.LOCAL_COURT_SEARCH_DISTRICT.REQUEST]: state =>
    state.merge(Immutable.fromJS({ isLoading: true })),

  [actionTypes.LOCAL_COURT_SEARCH_DISTRICT.ERROR]: (state, { error }) =>
    state.merge(Immutable.fromJS({ error, isLoading: false })),

  [actionTypes.LOCAL_COURT_SEARCH_DISTRICT.SUCCESS]: (state, action) => {
    let data = [];
    let searchResultsType = 'empty';

    if (!isEmpty(action.searchResults.cases)) {
      // result type cases
      data = action.searchResults.cases;
      searchResultsType = 'cases';
    } else if (!isEmpty(action.searchResults.parties)) {
      // result type parties
      data = action.searchResults.parties;
      searchResultsType = 'parties';
    }

    return state.merge({
      searchResultsType,
      searchType: 'Civil',
      data,
      receipts: action.searchResults.receipts || [],
      isLoading: false,
    });
  },

  [actionTypes.LOCAL_COURT_SEARCH_APPELLATE.REQUEST]: state =>
    state.merge(Immutable.fromJS({ isLoading: true })),

  [actionTypes.LOCAL_COURT_SEARCH_APPELLATE.ERROR]: (state, { error }) =>
    state.merge(Immutable.fromJS({ error, isLoading: false })),

  [actionTypes.LOCAL_COURT_SEARCH_APPELLATE.SUCCESS]: (state, action) => {
    let data = [];
    let searchResultsType = 'empty';

    if (!isEmpty(action.searchResults.cases)) {
      // result type cases
      data = action.searchResults.cases;
      searchResultsType = 'cases';
    } else if (!isEmpty(action.searchResults.parties)) {
      // result type parties
      data = action.searchResults.parties;
      searchResultsType = 'parties';
    }

    return state.merge({
      searchResultsType,
      searchType: 'Appellate',
      data,
      receipts: action.searchResults.receipts || [],
      isLoading: false,
    });
  },

  [actionTypes.LOCAL_COURT_SEARCH_RESET]: () => initialState,
});



// WEBPACK FOOTER //
// ./src/redux/reducers/localCourtSearchReducer.js